import native from '@zz-common/native-adapter'
import { env, setPicSize, url } from '@zz-common/zz-utils'
import Vue from 'vue'
import { compareVs } from './compareVersion'
/**
 * 获取url参数
 * @param {*} name
 * @param {*} url
 */
declare let window: any
export function getQueryString(name, url = '') {
  let link = location.href
  if (url) link = url
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(link) || ['', ''])[1].replace(
        /\+/g,
        '%20'
      )
    ) || ''
  )
}

//解析url 链接参数
export function getUrlParams(url) {
  url = url || window.location.href
  if (url.indexOf('?') < 0) return {}
  return url
    .replace(/^.+?\?/, '')
    .replace(/#.+/, '')
    .split('&')
    .filter((param) => param)
    .reduce((obj, param) => {
      const i = param.indexOf('=')
      const t = [param.slice(0, i), param.slice(i + 1)]
      obj[t[0]] = t[1]
      return obj
    }, {})
}

export function toParams(param) {
  let result = ''
  for (const name in param) {
    if (typeof param[name] != 'function') {
      result += '&' + name + '=' + encodeURI(param[name])
    }
  }
  return result.substring(1)
}

//获取平台信息
export function getPlatByUa() {
  const ua = navigator.userAgent
  const __iswa = getQueryString('__wa') || ''
  if (/58ZhuanZhuan$/g.test(ua)) {
    return 'zz'
  } else if (/MicroMessenger/g.test(ua)) {
    if (__iswa === '1') {
      return 'wa'
    } else {
      return 'wechat'
    }
  }
  return 'm'
}

// 判断是不是微信
export const isWx = () => {
  return /MicroMessenger/gi.test(window.navigator.userAgent.toLowerCase())
}

// 判断是不是APP
export const isZZ = () => {
  const ua = window.navigator.userAgent
  return ua.toLowerCase().indexOf('zhuanzhuan') > 0
}

//节流函数
export function throttle(fn, wait = 50) {
  // 上一次执行 fn 的时间
  let previous = 0
  // 将 throttle 处理结果当作函数返回
  return function (...args) {
    // 获取当前时间，转换成时间戳，单位毫秒
    const now = +new Date()
    // 将当前时间和上一次执行函数的时间进行对比
    // 大于等待时间就把 previous 设置为当前时间并执行函数 fn
    if (now - previous > wait) {
      previous = now
      fn.apply(this, args)
    }
  }
}

// 防抖函数
export function debounce(func, wait, immediate) {
  let timer
  return function () {
    const context = this
    const args = arguments

    if (timer) clearTimeout(timer)
    if (immediate) {
      const callNow = !timer
      timer = setTimeout(() => {
        timer = null
      }, wait)
      if (callNow) func.apply(context, args)
    } else {
      timer = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    }
  }
}

/**
 * 数据类型判断
 * @param  {Mix}     subject 待判断的数据
 * @param  {String}  type    数据类型名字
 * @return {Boolean}         判断结果
 */
export function is(subject, type) {
  return Object.prototype.toString.call(subject).substr(8, type.length).toLowerCase() === type
}

/**
 * 简单复制
 * @param  {Object} item 原始数据
 * @return {Object}      复制后的数据
 */
export function copy(item) {
  return JSON.parse(JSON.stringify(item))
}

/**
 * 是否是数组
 * @param  {Mix} subject 待判断的数据
 */
export function isObject(subject) {
  return is(subject, 'object')
}

// 合并对象
export function merge(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()
  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} })
        }
        merge(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }
  return merge(target, ...sources)
}

const requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60)
    }
  )
})()

const cancelAnimation = (function () {
  return (
    window.cancelAnimationFrame ||
    function (id) {
      clearTimeout(id)
    }
  )
})()

export function setIntervalPrecision(callback, delay) {
  // 生成并记录定时器ID
  const obj = window.interValPrecisionObj || (window.interValPrecisionObj = { num: 0 })
  obj.num++
  obj['n' + obj.num] = true
  const intervalId = obj.num
  // 开始时间
  const startTime = +new Date()
  // 已执行次数
  let count = 0
  // 延迟时间
  delay = delay || 0
  ;(function loop() {
    // 定时器被清除，则终止
    if (!obj['n' + intervalId]) return
    // 满足条件执行回调
    if (+new Date() > startTime + delay * (count + 1)) {
      count++
      callback(count)
    }
    requestAnimFrame(loop)
  })()
  return intervalId
}

export const setTimeoutPrecision = (cb, time = 0) => {
  let t = 0
  const timer = () => {
    t += 1
    if (t * (1000 / 60) > time) {
      cb()
      cancelAnimation(timer)
    } else {
      requestAnimFrame(timer)
    }
  }
  requestAnimFrame(timer)
}
//截取字符串中的数字和汉字 99新 ==>  99, 新 | 9成新 ==> 9 , 成新
export const formatVal = (params) => {
  if (!params) return
  const reg1 = /\d+/g
  const ms1 = params.match(reg1)?.[0]
  const reg2 = /[\u4e00-\u9fa5]/g
  const ms2 = params.match(reg2).join('')
  // 返回瑕疵的时候
  if (!ms1 && ms2) {
    if (ms2.indexOf('全新') > -1) {
      return { ms1: ms2.substring(0, 2), ms2: ms2.substring(2) }
    }
    return { ms1: ms2, ms2: '' }
  }
  return { ms1, ms2 }
}

/**
 * @description: 图片预加载
 * @param {*}
 * @return {*}
 */
export const loadFirstImage: Function = (
  imgSrc: string,
  w: number = 1000,
  h: number = 1000
): void => {
  if (imgSrc) {
    const firstImg = new Image()
    firstImg.src = setPicSize(imgSrc, w, h)
  }
}

//比较app版本号
export const versionCompare = (v1, v2) => {
  //将两个版本号拆成数组
  const arr1 = v1.split('.')
  const arr2 = v2.split('.')
  const minLength = Math.min(arr1.length, arr2.length)
  //依次比较版本号每一位大小
  for (let i = 0; i < minLength; i++) {
    if (parseInt(arr1[i]) != parseInt(arr2[i])) {
      return parseInt(arr1[i]) > parseInt(arr2[i]) ? 1 : -1
    }
  }
  // 若前几位分隔相同，则按分隔数比较。
  if (arr1.length == arr2.length) {
    return 0
  } else {
    return arr1.length > arr2.length ? 1 : -1
  }
}

// $ 判断iphoneX及以上
export const isIphonex = () => {
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
  }
  return false
}

export const isServer: boolean = Vue.prototype.$isServer

export const isMp: boolean = !isServer && !window && !navigator

export const UA = isServer || isMp ? '' : navigator.userAgent.toLowerCase()

export const isIOS = (() => {
  return /ios|iphone|ipad|ipod/.test(UA)
})()

export const isWechat = (() => {
  return /micromessenger/.test(UA)
})()
// $ zz-ui方法
export const isiPhoneX = (() => {
  if (!isIOS) return false

  const { width, height } = window.screen
  const isiPhoneXs = window.devicePixelRatio === 3 && width === 375 && height === 812
  const isiPhoneXsMax = window.devicePixelRatio === 3 && width === 414 && height === 896
  const isiPhoneXr = window.devicePixelRatio === 2 && width === 414 && height === 896
  const isiPhone12 = window.devicePixelRatio === 3 && width === 390 && height === 844
  const isiPhone12Max = window.devicePixelRatio === 3 && width === 428 && height === 926

  return isiPhoneXs || isiPhoneXsMax || isiPhoneXr || isiPhone12 || isiPhone12Max
})()

// 多维数组转一维数组

export const flatten = (arr) =>
  arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatten(val) : val), [])

/**
 * 获取指定 Cookie 值
 * @param {String} k 指定的 Cookie 名
 */
export const getCookie = (k, str) => {
  const res = RegExp('(^|;)' + encodeURIComponent(k) + '=([^;]*)').exec(str || document.cookie)
  return res && res[2]
}

export const inZZApp = native.in('zz')
// 判断转转App或找靓机App是否支持新半层
const canUseNewHalfScreen = () => {
  if (!inZZApp) return false
  let idx = -1
  if (inZZApp) idx = compareVs('9.16.0')
  if (idx < 0) return false
  if (env.$isIOS) {
    // 由于新版半层在IOS12系统中会导致系统崩溃，暂不使用新半层
    const deviceVersion = env.getIphoneVersion()
    return parseInt(deviceVersion) >= 13
  }
  return true
}

// 跳转半层webview
export const jumpHalfWebviewUrl = (targetUrl: string) => {
  let params: object = {
    needHideHead: 1,
    hiddenProgress: 1,
    isShowOnWindow: 1,
    webShowType: 1,
    topLeftRadius: 32,
    topRightRadius: 32,
    pHeight: 80
  }
  if (canUseNewHalfScreen()) {
    params = {
      needHideHead: 1,
      hiddenProgress: 1,
      wvHalfVer: 'v2',
      wvCornerRadius: 32,
      wvHeightRate: 0.8
    }
  }
  if (inZZApp) {
    targetUrl = url.setParams(params, targetUrl)
  }
  return targetUrl
}
// 加载js资源
export const loadJS = (url, cb) => {
  const head = window.document.getElementsByTagName('head')[0]
  const js = window.document.createElement('script')
  js.setAttribute('type', 'text/javascript')
  js.setAttribute('async', 'async')
  js.setAttribute('src', url)
  js.onload = cb && cb()
  head.appendChild(js)
}

// 判断当前元素是否在可视窗口
export const isContain = (dom) => {
  if (!dom) {
    return false
  }
  // 获取可视窗口的高度
  const screenHeight =
    window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  // 获取滚动条滚动的高度
  const scrollTop = document.documentElement.scrollTop
  // 获取元素偏移的高度。就是距离可视窗口的偏移量。
  const offsetTop = dom.offsetTop
  return offsetTop - scrollTop <= screenHeight
}
